import { render, staticRenderFns } from "./WorkNotice.vue?vue&type=template&id=e467ffcc&"
import script from "./WorkNotice.vue?vue&type=script&lang=js&"
export * from "./WorkNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports